import ajaxService from "../services/ajax-service";

export default function usePushNotifications() {

    const vapid_public_key = "BFF6iNjjlKYF_1KoBjg_xZgKYcfrU4FatBLGnxURimDT0yYlp54q1K0QbZVyQg9_z5lD9Byv70HvdSI6fgcbcKY";

    async function subscribeToPush() {
        if ("serviceWorker" in navigator && "PushManager" in window) {
            try {
                const permission = await Notification.requestPermission();
                if (permission !== "granted") {
                    return { success: false, message: "Notification permission denied" };
                }

                const registration = await navigator.serviceWorker.register("/service-worker.js");

                let subscription = await registration.pushManager.getSubscription();
                if (subscription) {
                    await subscription.unsubscribe();
                }

                subscription = await registration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: urlBase64ToUint8Array(vapid_public_key),
                });

                const response = await ajaxService.post("save-subscription", subscription);

                if (response?.data?.success) {
                    return { success: true };
                } else {
                    return { success: false, message: "Failed to save subscription" };
                }
            } catch (err) {
                console.error("Subscription failed:", err);
                return { success: false, message: err.message };
            }
        }

        return { success: false, message: "Push notifications not supported on this device" };
    }

    function urlBase64ToUint8Array(base64String) {
        const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
        const rawData = window.atob(base64);
        return new Uint8Array([...rawData].map((char) => char.charCodeAt(0)));
    }

    return { subscribeToPush };
}
